import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Loading from './Loading';

const Blogs = () => {
    const [blogs, setBlogs] = useState([]);
    const getBlogs = async () => {
        const { data } = await axios.get('https://hr-meheraj-portfolio.herokuapp.com/blogs/');
        setBlogs(data);
    }
    useEffect(() => {
        getBlogs();
    })

    return (
        <div className='my-[40px]'>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-[40px]">
                {blogs?.map(blog => {
                    return (
                        <Link to={`${blog?._id}`} className="card card-side flex-col h-[400px] shadow-xl" key={blog?._id}>
                            <figure><img src={blog?.imgURL} alt={blog?.title} className='h-[186px]' /></figure>
                            <div className="card-body blogs">
                                <h2 className="card-title text-[15px] sm:text-3xl">{blog?.title.slice(0, 60)}...</h2>
                                <p className='text-[12px]'>{blog?.body.slice(0, 80)}...</p>
                                {/* <div className="card-actions justify-end">
                                    <Link  to={`${blog?._id}`} className="btn-sm sm:btn-md sm:hidden btn btn-outline-primary hover:btn-primary">View Blog</Link>
                                </div> */}
                            </div>
                        </Link>
                    )
                })}
            </div>
        </div>
    );
}

export default Blogs;
